export const getSavedProposalsAll = ({ managedUsers, productsList }) => {
  if (!managedUsers?.length || !productsList?.length) return [];

  const listAllProposals = [];

  managedUsers?.map(it => {
    if (it.valueMap?.productMap) {
      // list of user saved proposals
      Object.keys(it.valueMap.productMap).map(proposalId => {
        listAllProposals.push({
          // user data
          ...it,
          // saved proposals props, last snapshot
          ...it.valueMap.productMap[proposalId].at(-1),
          // add selected financial product metadata
          financialProduct: productsList?.find(
            finProduct =>
              finProduct._id ===
              it.valueMap.productMap[proposalId].at(-1).productId
          ),
          proposalId,
        });
      });
    }
  });

  return listAllProposals;
};

export const getMassagedListEtf = list => {
  if (!list?.length) return [];

  return list.map(it => ({
    ...it,
    assetManager: it.AssetManager ?? it.CompanyName,
    broadCategory: it.AssetClass,
    globalCategory: it.Category,
    name: it.Name,
    ticker: it.Code,
    type: it.Type ?? "ETF",
  }));
};

export const getFilteredListProducts = ({ filters, list }) => {
  if (!list?.length) return [];

  if (!filters) return list;

  // list of enabled Type filters
  const types = filters?.types?.filter(it => it.enabled)?.map(it => it.name);

  // list of enabled Categories filters
  const categories = filters?.categories
    ?.filter(it => it.enabled)
    ?.map(it => it.name);

  // list of enabled Asset Managers filters
  const assets = filters?.assets?.filter(it => it.enabled)?.map(it => it.name);

  // if nothing enabled, ignore filter
  if (types?.length) {
    list = list.filter(it => types.includes(it.type));
  }

  if (categories?.length) {
    list = list.filter(it => categories.includes(it.broadCategory));
  }

  if (assets?.length) {
    list = list.filter(it => assets.includes(it.assetManager));
  }

  return list;
};

export const getVisibleProducts = ({ filters, productsList }) => {
  if (!filters) return productsList;
  if (!productsList) return undefined;

  let filteredProducts = productsList;

  if (filters.types.find(it => it.enabled)) {
    filteredProducts = filteredProducts.filter(productData =>
      filters.types
        .filter(it => it.enabled)
        .find(formItem => formItem.name === productData.type)
    );
  }

  if (filters.categories.find(it => it.enabled)) {
    filteredProducts = filteredProducts.filter(productData =>
      filters.categories
        .filter(it => it.enabled)
        .find(formItem => formItem.name === productData.broadCategory)
    );
  }

  if (filters.assets.find(it => it.enabled)) {
    filteredProducts = filteredProducts.filter(productData =>
      filters.assets
        .filter(it => it.enabled)
        .find(formItem => formItem.name === productData.assetManager)
    );
  }

  return filteredProducts;
};

export const isPermissionReadonly = type => type?.toLowerCase() === "view";

export const isTypeAffiliateAdvisor = type => type === "AffiliateAdvisor";

export const isTypeLevelWealthAdvisor = type => type === "LevelWealthAdvisor";

export const isTypeLevelWealthEnterpriseAdmin = type =>
  type === "LevelWealthEnterpriseAdmin";

export const isTypeLevelWealthEnterpriseAdminAdvisor = type =>
  type === "LevelWealthEnterpriseAdminAdvisor";

export const isTypeProPortalAdvisor = type => type === "ProPortalAdvisor";

export const isTypeProPortalAffiliateAdvisor = type =>
  type === "ProPortalAffiliateAdvisor";

export const isTypeSuperAdmin = type => type === "SuperAdmin";

export const isTypeAffiliateCompany = type => type === "Affiliate";

export const isTypeProPortalAffiliateCompany = type =>
  type === "ProPortalAffiliate";

export const isTypeProPortalCompany = type => type === "ProPortal";
